import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import RangeUserBalanceReport from '../../../../containers/RangeUserBalanceReport';

const UserBalance = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={RangeUserBalanceReport}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default UserBalance;
